import { render, staticRenderFns } from "./PersonalInformationView.vue?vue&type=template&id=4cba5489&scoped=true&"
import script from "./PersonalInformationView.vue?vue&type=script&lang=js&"
export * from "./PersonalInformationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cba5489",
  null
  
)

export default component.exports